// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200934/js/" + chunkId + "." + {"44":"2ce693dd","225":"903ad6db","481":"d9f0155b","486":"c791098d","770":"be083772"}[chunkId] + ".0.10683559578072865.chunk.js";
};